import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Receivable } from 'services/action';
import { Page } from 'ui/components';
import {
  Action,
  DetailReceivable,
  DetailPayment,
  DetailNote,
  Products,
  PaymentList
} from './component/detail';

const initialState = {
  data: null,
};

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Show']
  );

  const [{ data }, setState] = React.useState(initialState);

  const $onLoad = async (e) => {
    const req = await Dispatch(Receivable.$show(e));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="col-lg-11 col-md-11 bordered">
      <Page.Header
        pretitle="Invoice"
        title={data?.code}
        status={data?.document_status?.replace('new', 'proforma')}
        backTo="/receivable"
      >
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Header>

      <Page.Body className="bg-white border-top padding mt-3 mt-md-0">
        <div className="row">
          <div className="col-md-9">
            <DetailReceivable
              data={data}
            />
            <Products data={data} isLoading={StateLoading} />

            <div className="row">
              <div className="col-md-6">
                <DetailNote
                  data={data}
                />
              </div>
              <div className="col-md-6">
                <DetailPayment
                  data={data}
                />
              </div>
            </div>
          </div>
          <div className="border-start border-sm-none col-md-3 mt-3 mt-md-0">
            <PaymentList
              data={data}
              onSubmit={() => $onLoad(match?.params?.id)}
            />
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
